module.exports = __webpack_public_path__ + "img/alt.1dce9458.svg";